import { render, staticRenderFns } from "./AuthBackContainer.vue?vue&type=template&id=96748554&scoped=true&"
import script from "./AuthBackContainer.vue?vue&type=script&lang=js&"
export * from "./AuthBackContainer.vue?vue&type=script&lang=js&"
import style0 from "./AuthBackContainer.vue?vue&type=style&index=0&id=96748554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96748554",
  null
  
)

export default component.exports